import React, { Component } from "react"
import DynamicTable from "@atlaskit/dynamic-table"
import Moment from "moment-timezone"

var header = {
  cells: [
    {
      key: "0",
      content: "Datum",
      width: "8"
    },
    {
      key: "1",
      content: "Von",
      width: "8"
    },
    {
      key: "2",
      content: "Bis",
      width: "8"
    },
    {
      key: "3",
      content: "Dauer",
      width: "8"
    },
    {
      key: "4",
      content: "Pause",
      width: "8"
    }
  ]
}

var small_font_size = "10px"

export default class TimeEntryList extends Component {
  render() {
    console.log("render TimeEntryList")
    const { validation_errors } = this.props

    var rows = []
    if (validation_errors.days) {
      validation_errors.days.forEach(function(day) {
        var day_moment = new Moment(day.date)
        var content_date = day_moment.format("DD.MM.YYYY")

        var first_entry_of_day = true
        var padding_top = null

        var work_time_sum = 0
        var break_time_sum = 0

        day.timeEntries.forEach(function(entry) {
          var row = {}
          row.key = day.date
          row.cells = []
          work_time_sum += entry.duration
          break_time_sum += entry.breakAfterEntry

          if (first_entry_of_day) {
            row.cells.push({
              style: { fontSize: small_font_size },
              content: <b>{content_date}</b>
            })
            first_entry_of_day = false
          } else {
            padding_top = "0px"
            row.cells.push({
              style: { fontSize: small_font_size },
              content: ""
            })
          }

          var content_duration = Moment.duration(
            entry.duration,
            "seconds"
          ).format("h[h ]m[m]")

          var content_break = Moment.duration(
            entry.breakAfterEntry,
            "seconds"
          ).format("h[h ]m[m]")

          row.cells.push({
            style: { fontSize: small_font_size, paddingTop: padding_top },
            content: Moment(entry.start).format("HH[:]mm")
          })

          row.cells.push({
            style: { fontSize: small_font_size, paddingTop: padding_top },
            content: Moment(entry.stop).format("HH[:]mm")
          })

          row.cells.push({
            style: { fontSize: small_font_size, paddingTop: padding_top },
            content: content_duration
          })

          row.cells.push({
            style: { fontSize: small_font_size, paddingTop: padding_top },
            content: content_break
          })

          rows.push(row)
        })

        var rowBuffer = {}
        rowBuffer.cells = []

        if (day.description) {
          rowBuffer.key = day.date + "no_work_day"
          rowBuffer.cells.push({
            style: { fontSize: small_font_size },
            content: <b>{content_date}</b>
          })
          rowBuffer.cells.push({
            style: { fontSize: small_font_size },
            content: <b>{day.description}</b>
          })

          rowBuffer.cells.push({})
          rowBuffer.cells.push({})
          rowBuffer.cells.push({})

          rows.push(rowBuffer)
        } else {
          rowBuffer.key = day.date + "sum"
          rowBuffer.cells.push({})
          rowBuffer.cells.push({})
          rowBuffer.cells.push({})

          var content_work_time_sum = Moment.duration(
            work_time_sum,
            "seconds"
          ).format("h[h ]m[m]")

          var content_break_time_sum = Moment.duration(
            break_time_sum,
            "seconds"
          ).format("h[h ]m[m]")

          rowBuffer.cells.push({
            style: { fontSize: small_font_size },
            content: <b>{content_work_time_sum}</b>
          })

          rowBuffer.cells.push({
            style: { fontSize: small_font_size },
            content: <b>{content_break_time_sum}</b>
          })
          rows.push(rowBuffer)
        }
      })
    }

    return (
      <div style={{ pageBreakAfter: "always" }}>
        <DynamicTable caption="" head={header} rows={rows} isFixedSize />
        {validation_errors &&
        validation_errors.days &&
        validation_errors.days.length === 0 ? (
          <h2>Keine Einträge im ausgewählten Zeitraum</h2>
        ) : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TimeEntryList.jsx